import Swal from 'sweetalert2';
import ConsultantLayout from '../commonlayouts/consultantlayout';

export const JoinMeetingButton = () => {
  const joinStaticRoom = () => {
    const staticRoomName = "interview-abc981";
    const fullUrl = `${window.location.origin}/Jitisimeeting/${staticRoomName}`;

    // ✅ Copy to clipboard
    navigator.clipboard.writeText(fullUrl)
      .then(() => {
        Swal.fire(`Meeting link copied`);
      })
      .catch((err) => {
        Swal.fire('Failed to copy URL:', err);
      });

    // ❌ No navigation
  };

  return (
    <ConsultantLayout>
          <div className='mt-5'>
    <h2 style={{ color: "#00a7ac", marginLeft: '10px' }}>Meeting</h2>
  </div>
  <hr/>
  <div style={{marginBottom:500}}>
      <button onClick={joinStaticRoom}>Copy Interview Meeting Link</button>
      </div>
    </ConsultantLayout>
  );
};
